export const template = (context, html) => html``;
